import { application } from 'lib/pages-common'
import HowItWorksTabs from 'pages/home-page/how-it-works-tabs-controller'
import GlideSliderController from 'controllers/glide-slider-controller'
import ModalVideoController from 'modal-video-controller'
import 'intent_form/component_preview'

application.register('modal-video-controller', ModalVideoController)
application.register('glide-slider', GlideSliderController)
application.register('tabs', HowItWorksTabs)
